export default __webpack_public_path__ + "static/media/encarcerations-graph.e424fff5.png";